import * as style from './style.css';
import * as DOMPurify from 'isomorphic-dompurify';
import { UIText2 } from '@cian/ui-kit';

interface IDescriptionProps {
  text: string;
}

export const Description = ({ text }: IDescriptionProps) => {
  return (
    <UIText2>
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
        className={style['container']}
      />
    </UIText2>
  );
};
